import * as types from './types'
import { createReducer } from '../../utils'

const sessionReducer = createReducer({})({
	[types.FETCH_SESSION_COMPLETED]: (state, action) => action.payload.data,
	[types.FETCH_SESSION_FAILED]: (state, action) => {},
})

export default sessionReducer
